<div class="row center">
  <div class="column">
    <div class="column center header">
      <img
        [src]="currentCustomer?.logoUrlBase + 'login-logo.svg'"
        [alt]="'logo-' + currentCustomer?.domain"
      />
      <span *ngIf="currentCustomer?.domain === securityDomain">{{ currentCustomer?.name }}</span>
    </div>
    <div *ngIf="submittedCorrect">
      <app-info-shadow-box
        [icon]="'success-icon'"
        [title]="'ResetPasswordComponent.passwordChanged'"
        [text]="'ResetPasswordComponent.yourPasswordIsChangedNow'"
        [hasButton]="true"
        [buttonText]="'UserActivateAccountComponent.goToVerticalSelector'"
        [redirectPath]="'vertical-selector'"
      ></app-info-shadow-box>
    </div>
    <div *ngIf="!submittedCorrect">
      <div *ngIf="validToken; else elseBlock">
        <div class="column">
          <form [formGroup]="resetPasswordForm" class="column gap">
            <div class="column text-align-center">
              <h2>{{ 'ResetPasswordComponent.setNewPassword' | translate }}</h2>
            </div>

              {{ 'passwordManagement.description' | translate }}
              <ul>
                <li>{{ 'passwordManagement.requirements.first' | translate }}</li>
                <li>{{ 'passwordManagement.requirements.second' | translate }}</li>
                <li>{{ 'passwordManagement.requirements.third' | translate }}</li>
                <li>{{ 'passwordManagement.requirements.fourth' | translate }}</li>
              </ul>

            <div class="column center gap">
              <mat-form-field class="password">
                <mat-label>{{ 'ResetPasswordComponent.password' | translate }}</mat-label>
                <app-show-hide-password>
                  <input
                    matInput
                    (ngModelChange)="getPasswordScore()"
                    placeholder="{{ 'ResetPasswordComponent.password' | translate }}"
                    type="password"
                    formControlName="password"
                    name="password"
                    required
                  />
                </app-show-hide-password>
              </mat-form-field>
              <mat-error *ngIf="resetPasswordForm.controls.password.hasError('required') && resetPasswordForm.controls.password.touched">
                {{ 'passwordManagement.errors.Field-required' | translate }}
              </mat-error>
              <mat-error *ngIf="resetPasswordForm.controls.password.hasError('minlength')">
                {{ 'passwordManagement.errors.Field-min-length' | translate }}
              </mat-error>
              <mat-error *ngIf="!resetPasswordForm.controls.password.hasError('minlength') && resetPasswordForm.controls.password.hasError('pattern')">
                {{ 'passwordManagement.errors.Field-pattern' | translate }}
              </mat-error>
              <app-password-strength-bar
                (strengthChanged)="changeScore($event)"
                [token]="token"
                [isForgotPassword]="true"
                [passwordToCheck]="passwordToCheck"
              >
              </app-password-strength-bar>
              <mat-form-field class="password padding-bottom">
                <mat-label>{{ 'ResetPasswordComponent.repeatPassword' | translate }}</mat-label>

                <app-show-hide-password>
                  <input
                    matInput
                    placeholder="{{ 'ResetPasswordComponent.repeatPassword' | translate }}"
                    type="password"
                    formControlName="repeatPassword"
                    name="repeatPassword"
                    required
                /></app-show-hide-password>
              </mat-form-field>
              <p *ngIf="resetPasswordForm?.errors && resetPasswordForm.get('repeatPassword')?.touched" class="error">
                {{ 'ResetPasswordComponent.passwordsDontMatch' | translate }}
              </p>
              <button
                mat-raised-button
                class="eva-button"
                [disabled]="resetPasswordForm.invalid || scorePassword < minScore"
                type="submit"
                (click)="resetPassword()"
              >
                {{ 'ResetPasswordComponent.changePasswordButton' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <ng-template #elseBlock>
      <app-info-shadow-box
        [icon]="'alert-icon'"
        [title]="'UserActivateAccountComponent.checkTheTokenActivate'"
        [text]="'UserActivateAccountComponent.invalidToken'"
        [buttonText]="'UserActivateAccountComponent.goToVerticalSelector'"
        [redirectPath]="'vertical-selector'"
        [hasButton]="true"
      ></app-info-shadow-box>
    </ng-template>
  </div>
</div>
